module.exports = __webpack_public_path__ + "img/bidders_empty_new.2a0b1243.svg";